import React from 'react'
import { Edit } from 'react-admin'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import ProfessionalFiguresForm from './ProfessionalFiguresForm'

const ProfessionalFiguresEdit: React.FC = () => {
  return (
    <SectionWrapper>
      <Edit>
        <ProfessionalFiguresForm toolbar={<WithDeleteModalToolbar />} />
      </Edit>
    </SectionWrapper>
  )
}

export default ProfessionalFiguresEdit
